import React from 'react';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { TableColumns } from '@models/column';
import { JoinConditionEditor, TableInlineEditor } from './components';
import { JoinDraft, JoinConditionDraft } from './models';
import {
  useFeatureDescriptorEditorContext,
  FeatureDescriptorEditorActions,
} from './context';

export interface JoinEditorProps {
  tableColumns: TableColumns;
}

export const JoinEditor = ({ tableColumns }: JoinEditorProps) => {
  const [state, dispatch] = useFeatureDescriptorEditorContext();
  const join = state.join as JoinDraft;

  function addCondition() {
    dispatch(FeatureDescriptorEditorActions.Join.addNewCondition());
  }

  function removeCondition(id: number) {
    dispatch(FeatureDescriptorEditorActions.Join.removeCondition({ id }));
  }

  const tables = Object.keys(tableColumns);

  return (
    <div style={{ display: 'inline-flex' }}>
      <div
        style={{
          height: '26px',
          alignItems: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        Join(
        {
          <TableInlineEditor
            label="target_table"
            tables={tables}
            value={join.target_table}
            onValueChange={value =>
              dispatch(
                FeatureDescriptorEditorActions.setDraftField({
                  field: 'join.target_table',
                  value,
                })
              )
            }
          />
        }
        <span style={{ marginRight: '6px' }}>,</span>
        {
          <TableInlineEditor
            label="source_table"
            tables={tables}
            value={join.source_table}
            onValueChange={value =>
              dispatch(
                FeatureDescriptorEditorActions.setDraftField({
                  field: 'join.source_table',
                  value,
                })
              )
            }
          />
        }
        <span style={{ marginRight: '6px' }}>,</span>
        join_conditions=[
      </div>
      <div>
        <div>
          {
            <>
              {state.join.join_conditions.map(
                (condition: JoinConditionDraft, idx: number) => {
                  return (
                    <div
                      key={condition.id}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                      }}
                    >
                      <IconButton
                        color="default"
                        style={{ height: '26px' }}
                        onClick={() => removeCondition(condition.id)}
                      >
                        <DeleteIcon style={{ width: '16px' }} />
                      </IconButton>
                      <JoinConditionEditor
                        conditionId={condition.id}
                        tableColumns={tableColumns}
                      />
                      {idx + 1 === state.join.join_conditions.length && (
                        <span
                          style={{
                            alignSelf: 'end',
                            flex: '1 0 auto',
                            marginLeft: '6px',
                            height: '26px',
                            lineHeight: '26px',
                          }}
                        >
                          ])
                          <Button variant="text" onClick={addCondition}>
                            + add new join
                          </Button>
                        </span>
                      )}
                    </div>
                  );
                }
              )}
            </>
          }
        </div>
      </div>
    </div>
  );
};
